const formatPhoneNumber = (phoneNumber: string): string =>
  `0${phoneNumber.slice(3)}`;

export default formatPhoneNumber;
